import React from "react";

function NewsCardBuffer(props) {
  return (
    <div
      className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800"
      aria-hidden
    >
      <div className="flex flex-col gap-2">
        <span className="h-5 w-3/4 rounded bg-gray-200 animate-pulse dark:bg-gray-700" />
        <span className="h-4 w-full rounded bg-gray-100 animate-pulse dark:bg-gray-700" />
        <span className="h-4 w-2/3 rounded bg-gray-100 animate-pulse dark:bg-gray-700" />
      </div>
    </div>
  );
}

export default NewsCardBuffer;
